<div class="tag-title">
    <h2 mat-dialog-title>Color Picker</h2>
</div>
<mat-dialog-content class="mat-typography">
    
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button class="popup-save btn-primary" mat-button type="submit" (click)="save()">Save & Close</button>
    <button mat-button mat-dialog-close class="silver">Cancel</button>
</mat-dialog-actions>